import { createStackNavigator, createAppContainer } from "react-navigation";
import HomeComponent from "./src/components/screens/home";
import CreateGameComponent from "./src/components/screens/createGame";
import BuildLevelsComponent from "./src/components/screens/buildLevels";
import JoinGameComponent from "./src/components/screens/joinGame";
import CurrentGameComponent from "./src/components/screens/currentGame";

const MainNavigator = createStackNavigator(
  {
    Home: HomeComponent,
    CreateGame: CreateGameComponent,
    BuildLevels: BuildLevelsComponent,
    JoinGame: JoinGameComponent,
    CurrentGame: CurrentGameComponent,
  },
  {
    initialRouteName: "Home",
    defaultNavigationOptions: {
      headerTintColor: "#000",
      headerStyle: {
        backgroundColor: "#fff",
        shadowColor: "transparent",
        borderBottomWidth: 0,
        elevation: 0,
      },
    },
  }
);

const App = createAppContainer(MainNavigator);

export default App;
